import { Suggestion } from "@interfaces";
import { styled, Box, Button, Typography } from "@mui/material";
import { Search } from "@mui/icons-material";

const MostPopularSearchesContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "left",
  width: "100%",
});

const SuggestionButton = styled(Button)(({ theme }) => ({
  display: "flex",
  border: "none",
  background: theme.palette.background.white,
  padding: "12px 16px",
  width: "100%",
  cursor: "pointer",
  justifyContent: "space-between",
  gap: "16px",
  alignItems: "center",
  borderBottom: "1px solid #eaeaea",
  "&:hover": {
    background: theme.palette.background.lightGray,
  },
}));

const SuggestionTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.gray,
  textTransform: "capitalize",
}));

const SearchIcon = styled(Search)(({ theme }) => ({
  color: theme.palette.text.gray,
}));

interface Props {
  className?: string;
  onItemClick: (item: Suggestion) => void;
  mostSearchedQueries: Suggestion[];
  children?: React.ReactNode;
}

export const MostPopularSearches: React.FC<Props> = ({
  className,
  onItemClick,
  mostSearchedQueries,
  children,
}) => {
  return (
    <MostPopularSearchesContainer className={className}>
      {children
        ? children
        : mostSearchedQueries.map((item: Suggestion, i: number) => (
            <SuggestionButton
              key={`most-popular-search-${i}`}
              onClick={() => onItemClick(item)}
              endIcon={<SearchIcon />}
            >
              <SuggestionTitle variant="body1">{item.text}</SuggestionTitle>
            </SuggestionButton>
          ))}
    </MostPopularSearchesContainer>
  );
};
